import React, { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { handleTokenAndPostRequest } from "../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faQrcode, faHome } from "@fortawesome/free-solid-svg-icons";
import PropertyQrTab from "./qr/PropertyQrTab";
import GenericQrTab from "./qr/GenericQrTab";
import StatsTab from "./qr/StatsTab";

export default function QrCode() {
  const [aggData, setAggData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [slug, setSlug] = useState("");
  const [qrCodeBase64, setQrCodeBase64] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [slugLoading, setSlugLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("stats");

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const agency_id = user.agent_details?.agency_id;
        if (!agency_id) {
          setAggData([]);
          setLoading(false);
          return;
        }
        const aggRes = await handleTokenAndPostRequest(
          `${window.api_host}/qr-scan-stats-agg`,
          { agency_id }
        );
        setAggData(Array.isArray(aggRes.data) ? aggRes.data : []);
      } catch (e) {
        setAggData([]);
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (!slug && !slugLoading) {
      setSlugLoading(true);
      handleTokenAndPostRequest(`${window.api_host}/agent-onboarding-info`, {})
        .then((res) => {
          if (res.data && res.data.landing_page_slug) {
            setSlug(res.data.landing_page_slug);
            setQrCodeBase64(res.data.qr_code_png_base64 || "");
            setQrCodeUrl(res.data.qr_code_url || "");
          }
        })
        .finally(() => setSlugLoading(false));
    }
  }, [slug, slugLoading]);

  const tabs = [
    { id: "stats", label: "Stats & Setup", icon: faChartBar },
    { id: "generic", label: "Generic QR Flyer", icon: faQrcode },
    { id: "property", label: "Per-Property QR PDF", icon: faHome },
  ];

  return (
    <div style={{ display: "flex", background: "#f6f8fa" }}>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          padding: isMobile ? "0 16px" : "0 32px",
          boxSizing: "border-box",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            paddingTop: isMobile ? 72 : 32,
            flex: 1,
            boxSizing: "border-box",
            width: "100%",
            maxWidth: 900,
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 40,
          }}
        >
          <h1 style={{ fontSize: isMobile ? 26 : 32, fontWeight: 700, margin: "0 0 8px 0", color: "#1f2937" }}>
            QR Code Campaigns
          </h1>
          <p style={{ color: "#6b7280", fontSize: 15, marginBottom: 20, lineHeight: 1.6 }}>
            Create and track QR code campaigns for your print materials. Track
            scans, generate a branded flyer, or print one-per-property cards.
          </p>

          <div
            style={{
              display: "flex",
              gap: 4,
              padding: 4,
              background: "#eef2f7",
              borderRadius: 10,
              marginBottom: 24,
              width: "fit-content",
              maxWidth: "100%",
              overflowX: "auto",
            }}
          >
            {tabs.map((t) => {
              const active = activeTab === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setActiveTab(t.id)}
                  style={{
                    background: active ? "#fff" : "transparent",
                    color: active ? "#111827" : "#4b5563",
                    border: "none",
                    borderRadius: 8,
                    padding: "10px 16px",
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: active ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    whiteSpace: "nowrap",
                  }}
                >
                  <FontAwesomeIcon icon={t.icon} /> {t.label}
                </button>
              );
            })}
          </div>

          {activeTab === "stats" && (
            <StatsTab
              isMobile={isMobile}
              loading={loading}
              aggData={aggData}
              slug={slug}
              slugLoading={slugLoading}
              qrCodeUrl={qrCodeUrl}
              qrCodeBase64={qrCodeBase64}
            />
          )}

          {activeTab === "generic" && (
            <GenericQrTab
              isMobile={isMobile}
              qrCodeUrl={qrCodeUrl}
              slugLoading={slugLoading}
            />
          )}

          {activeTab === "property" && <PropertyQrTab isMobile={isMobile} />}
        </div>
      </div>
    </div>
  );
}
